<script>
import { MAX_FULL_NAME_LENGTH } from '@/constants';

export default {
  methods: {
    validateFullName(isPaymentFormValidation = false) {
      this.$nextTick(() => {
        if (this.showFullnameField) {
          if (!this.$refs.fullName?.validate) {
            const { value } = this.$refs.fullName;
            if (value?.length > MAX_FULL_NAME_LENGTH) {
              this.$set(
                this.errors,
                'full_name',
                'Characters limit exceeded, please use a shorter version.',
              );
            } else {
              this.$set(
                this.errors,
                'full_name',
                isPaymentFormValidation ? 'Please enter your full name in English.' : 'Please enter your full name.',
              );
            }
          } else {
            this.$delete(this.errors, 'full_name');
          }
        }
      });
    },
  },
};

</script>
